const errors = {
  en: ['The specific torque field cannot be empty.', 'The specific torque field must be a number.'],
  nl: ['Het veld voor specifiek koppel mag niet leeg zijn.', 'Het veld voor specifiek koppel moet een getal zijn.'],
  de: [
    'Das Feld für das spezifische Drehmoment darf nicht leer sein.',
    'Das Feld für das spezifische Drehmoment muss eine Zahl sein.',
  ],
  es: ['El campo de par específico no puede estar vacío.', 'El campo de par específico debe ser un número.'],
  fr: ['Le champ de couple spécifique ne peut pas être vide.', 'Le champ de couple spécifique doit être un nombre.'],
};

const { lang } = document.getElementsByTagName('html')[0];
const localizedErrors = errors[lang];

const conversionFactors = {
  gfcm: 13825.4955,
  kgfcm: 13.8254955,
  kgfm: 0.138254955,
  mNm: 1355.817948841476,
  cNm: 135.5817948841476,
  Ncm: 0.1355817948841476,
  Nm: 1.355817948841476,
  ozfin: 192,
  lbfin: 12,
  lbfft: 1,
};

const unitNames = {
  gfcm: 'gf-cm',
  kgfcm: 'kgf-cm',
  kgfm: 'kgf-m',
  mNm: 'mN-m',
  cNm: 'cN-m',
  Ncm: 'N-cm',
  Nm: 'N-m',
  ozfin: 'ozf-in',
  lbfin: 'lbf-in',
  lbfft: 'lbf-ft',
};

function ErrorOutput(errorText) {
  const errorBoxElement = document.getElementById('error_box');

  if (errorBoxElement) {
    errorBoxElement.innerHTML = errorText;
  }
}

function ClearData() {
  for (const toUnit of Object.keys(conversionFactors)) {
    const conversionResults = document.getElementById(unitNames[toUnit]);

    if (conversionResults) {
      conversionResults.value = '';
    }
  }
}

function Calculate() {
  ClearData();

  const inputElement = document.getElementById('torque');
  let inputValue = inputElement.value;

  if (inputValue === '') {
    return ErrorOutput(localizedErrors[0]);
  }

  if (Number.isNaN(Number(inputValue))) {
    return ErrorOutput(localizedErrors[1]);
  }

  inputValue = parseFloat(inputValue);
  const fromUnit = document.getElementById('unit').value.replace(/[·.]/g, '');

  for (const toUnit of Object.keys(conversionFactors)) {
    const convertedValue = (inputValue * conversionFactors[toUnit]) / conversionFactors[fromUnit];
    const resultElement = Math.round(convertedValue * 10000000) / 10000000;
    const conversionResults = document.getElementById(unitNames[toUnit]);

    if (conversionResults) {
      conversionResults.value = resultElement;
    }
  }

  ErrorOutput('');
} // Calculate()

document.addEventListener('DOMContentLoaded', () => {
  if (document.getElementsByClassName('calculator_form').length > 0) {
    const convertButtonElement = document.getElementById('convert-button');

    if (convertButtonElement) {
      convertButtonElement.addEventListener('click', Calculate);
    }
  }
});
